import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus"
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle"
import { faBolt } from "@fortawesome/free-solid-svg-icons/faBolt"
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight"
import { faExclamation } from "@fortawesome/free-solid-svg-icons/faExclamation"
import { faHandPointRight } from "@fortawesome/free-solid-svg-icons/faHandPointRight"
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes"
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck"

import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF"
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter"
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons/faLinkedinIn"

import { library, dom } from "@fortawesome/fontawesome-svg-core"

library.add(faPlus)
library.add(faInfoCircle)
library.add(faBolt)
library.add(faChevronRight)
library.add(faExclamation)
library.add(faHandPointRight)
library.add(faTimes)
library.add(faCheck)

library.add(faFacebookF)
library.add(faTwitter)
library.add(faLinkedinIn)

dom.watch()
